import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit, output, inject } from '@angular/core';
import { StripeAPIService } from '../../services/stripe-api.service';
import { StripeBody, StripePriceData } from '../create-subscription-dialog/create-subscription-dialog.component';
import { SubscriptionBuilderComponent, SubBuilderData } from '../subscription-builder/subscription-builder.component';
import { SubscriptionEditorComponent, SubEditorData } from '../subscription-editor/subscription-editor.component';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';


import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';

@Component({
  selector: 'app-stripe-customer-subscriptions',
  imports: [CommonModule, MatButtonModule, MatCardModule, MatMenuModule],
  templateUrl: './stripe-customer-subscriptions.component.html',
  styleUrl: './stripe-customer-subscriptions.component.css'
})
export class StripeCustomerSubscriptionsComponent implements OnInit {

  @Input() customerStripeId: string = "";
  @Input() customer: any;
  readonly dialog = inject(MatDialog);
  cardActionClick = output<any>();
  stripeSubs: any[] = [];
  stripeProductIds: string[] = [];
  stripeProducts: any[] = [];
  deleteId: string = '';

  constructor(private stripeApi: StripeAPIService, public confirmDialog: MatDialog) { }

  ngOnInit() {
    this.getSubs()
  }

  async getProducts() {
    const res: any = await this.stripeApi.getProductsByIds(this.stripeProductIds);
    if (res) {
      this.stripeProducts = res.data;
      this.setProductNamesForSubs();
    }
    console.log('this.stripeProducts', this.stripeProducts);
  }

  async getSubs() {
    const res: any = await this.stripeApi.getSubscriptionsForCustomer(this.customer.stripe_id);
    if (res) {
      this.stripeSubs = res.data;
      console.log('subs (res.data)', this.stripeSubs);
      this.getProductIdsFromSubs();
      this.getProducts();
    }
    console.log('this.stripeSubs', this.stripeSubs);
  }

  getProductIdsFromSubs() {
    this.stripeProductIds = [];
    for (let sub of this.stripeSubs) {
      for (let price of sub.items.data) {
        this.stripeProductIds.push(price.price.product);
      }
    }
  }

  getProductName(item: any) {
    console.log('getProductName starting for item', item);
    let product = this.stripeProducts.find(x => x.id == item.price.product);
    if (!product) return item.price.product;
    return product.name;
  }

  setProductNamesForSubs() {
    for (let sub of this.stripeSubs) {
      for (let item of sub.items.data) {
        item.productName = this.getProductName(item);
      }
    }
  }

  openSubscriptionEditor(stripeBody: StripeBody, editType: string): void {
    console.log('openSubscriptionEditor clicked stripeBody', stripeBody);
    let builderData: SubEditorData = {
      customer: this.customer || '',
      editType: editType
    };

    if (stripeBody) {
      builderData.stripeBody = stripeBody;
    }

    const dialogRef = this.dialog.open(SubscriptionEditorComponent, { data: builderData });

    dialogRef.afterClosed().subscribe(result => {
      if (result) console.log('result', result)
    });
  }

  editBillingSchedule(card: any) {
    this.openSubscriptionEditor(card as StripeBody, 'edit_schedule');
  }

  editServicesOrPricing(card: any) {
    console.log('Edit Pricing Clicked for card', card);
    this.openSubscriptionEditor(card as StripeBody, 'edit_services_or_pricing');
  }

  editSubscription(card: any) {
    console.log('Change Service Address Clicked for card', card);
    this.openSubscriptionEditor(card as StripeBody, 'edit_sub');
  }

  deleteSubscription(card: any) {
    console.log('deleteSubscription clicked for card', card);
    this.deleteId = card.id;
    this.openConfirmationDialog();
    //this.cardActionClick.emit({ action: 'delete', card: card });
  }

  async cancelSub (){
    let canceled = await this.stripeApi.cancelSubscription(this.deleteId);
    if (canceled){
      this.getSubs();
    }
  }

  openConfirmationDialog(): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '300px',
      data: { message: 'Are you sure you want to delete this item?' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // confirmed
        console.log('openConfirmationDialog Action confirmed!');
        this.cancelSub ();
      } else {
        // cancelled
        console.log('openConfirmationDialog Action cancelled.');
      }
    });
  }

}
